/**
 * Visibility-based trigger using IntersectionObserver.
 * Unlike position-based scroll triggers it reacts to what is actually rendered,
 * so it keeps working inside editor frames / late layout shifts.
 * play()  — element entered the viewport
 * reset() — element went back below the viewport (so it can replay)
 */
export default function onView(
  el: Element | null | undefined,
  play: () => void,
  reset?: () => void,
  margin = '0px 0px -12% 0px',
): () => void {
  if (!el || typeof IntersectionObserver === 'undefined') {
    play();
    return () => {};
  }
  let shown = false;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting && !shown) {
        shown = true;
        play();
      } else if (!e.isIntersecting && shown && e.boundingClientRect.top > 0 && reset) {
        shown = false;
        reset();
      }
    });
  }, { rootMargin: margin, threshold: 0 });
  io.observe(el);
  return () => io.disconnect();
}